import countries from "i18n-iso-countries";
import en from "i18n-iso-countries/langs/en.json";

countries.registerLocale(en);

export function toCountryName(codeOrName) {
  const v = String(codeOrName || "").trim();
  if (!v) return "—";

  // ISO2
  if (v.length === 2) {
    return (
      countries.getName(v.toUpperCase(), "en", { select: "official" }) ||
      countries.getName(v.toUpperCase(), "en") ||
      v
    );
  }

  // ISO3
  if (v.length === 3) {
    const iso2 = countries.alpha3ToAlpha2(v.toUpperCase());
    return (
      (iso2 &&
        (countries.getName(iso2, "en", { select: "official" }) ||
          countries.getName(iso2, "en"))) ||
      v
    );
  }

  // already a name
  return v;
}
